import { render } from "./in-ve.vue?vue&type=template&id=0c18483c&scoped=true"
import script from "./in-ve.vue?vue&type=script&lang=js"
export * from "./in-ve.vue?vue&type=script&lang=js"

import "./in-ve.vue?vue&type=style&index=0&id=0c18483c&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c18483c"]])

export default __exports__